import 'angular:locale/data:de';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
